import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@/api/client';
import type { DashboardSummary, Alert } from '@/api/types';

type AlertListResponse = {
  alerts: Alert[];
  total: number;
  page: number;
  size: number;
};

export function useDashboardSummary(locationId?: string) {
  const params = locationId ? `?locationId=${locationId}` : '';
  return useQuery({
    queryKey: ['dashboardSummary', locationId ?? 'all'],
    queryFn: () => apiClient<DashboardSummary>(`/admin/reports/summary${params}`),
    refetchInterval: 60_000,
  });
}

export function useActiveAlerts(size = 5, locationId?: string) {
  const locParam = locationId ? `&locationId=${locationId}` : '';
  return useQuery({
    queryKey: ['activeAlerts', size, locationId ?? 'all'],
    queryFn: () =>
      apiClient<AlertListResponse>(`/admin/alerts?status=ACTIVE&size=${size}${locParam}`),
    refetchInterval: 60_000,
  });
}
